import React, { ReactElement } from "react";
import { hoursToTime } from "../../date";
import { IntegrationValueType } from "../../__generated__/api";

export default function DisplayValue({
    type, value, text,
}: {
    type: IntegrationValueType; value: string; text: string
}): ReactElement | null {
    if (type === IntegrationValueType.Email) {
        return (
            <a href={`mailto:${value}`}>{value}</a>
        );
    } if (type === IntegrationValueType.Link) {
        return (
            <a href={value} target="_blank" rel="noreferrer">{text ?? value}</a>
        );
    } if (type === IntegrationValueType.Phone) {
        return (
            <a href={`tel:${value}`}>{value}</a>
        );
    } if (type === IntegrationValueType.Timezone) {
        try {
            return (
                <>
                    {new Date().toLocaleString(undefined, {
                        timeZone: value,
                    })}
                </>
            );
        } catch {
            return null;
        }
    }
    if (type === IntegrationValueType.DateTime) {
        const date = new Date(value);
        return (
            <span>
                {date.toLocaleDateString()}
                {" "}
                {date.toLocaleTimeString()}
            </span>
        );
    }
    if (type === IntegrationValueType.Date) {
        const date = new Date(value);
        return (
            <span>
                {date.toLocaleDateString()}
            </span>
        );
    }
    if (type === IntegrationValueType.Time) {
        const date = new Date(`2020-01-01T${hoursToTime(parseInt(value, 10))}`);
        return (
            <span>
                {date.toLocaleTimeString()}
            </span>
        );
    }

    return <span>{value}</span>;
}
